import React, { useCallback, useState } from 'react'

import { ZapierActionModal } from './modals/ZapierActionModal'

export interface ZapierAction {
  openZapier: () => void
  zapierModal: React.ReactNode
}

// Encapsulates the open state and the (base, "coming soon") modal so any dropdown
// can offer the "Send to Zapier" action without duplicating the wiring.
export const useZapierAction = (): ZapierAction => {
  const [open, setOpen] = useState(false)
  const openZapier = useCallback(() => setOpen(true), [])
  const closeZapier = useCallback(() => setOpen(false), [])

  return {
    openZapier,
    zapierModal: <ZapierActionModal open={open} onClose={closeZapier} />,
  }
}
